// extracted by mini-css-extract-plugin
module.exports = {"cookieContainer":"CookiePolicy_cookieContainer__aDpCV","closeButton":"CookiePolicy_closeButton___m9eY","cookieContent":"CookiePolicy_cookieContent__BTQy_"};